import type { MediaFilters } from '@cobliteam/common-types';
import type { StateCreator } from 'zustand';

export interface MediaDetailsSliceState {
  detailMediaId?: string;
  detailMediaFilters?: MediaFilters;
  hasPendingChanges?: boolean;
  startingSafetyReview: boolean;
  useTableFilters?: boolean;
  setDetailMediaAndFilters: (id: string, mediaFilters: MediaFilters) => void;
  setDetailMediaId: (id?: string) => void;
  setDetailMediaFilters: (mediaFilters: MediaFilters) => void;
  setHasPendingChanges: (hasPendingChanges: boolean) => void;
  setStartingSafetyReview: (startingSafetyReview: boolean) => void;
  setUseTableFilters: (useTableFilters: boolean) => void;
}

type StateCreatorMediaDetails = StateCreator<MediaDetailsSliceState, [['zustand/devtools', never]], [], MediaDetailsSliceState>;

const mediaDetailsSlice: StateCreatorMediaDetails = (set) => ({
  detailMediaId: undefined,
  detailMediaFilters: undefined,
  startingReview: false,
  hasPendingChanges: false,
  startingSafetyReview: false,
  useTableFilters: false,
  setDetailMediaAndFilters: (id: string, mediaFilters: MediaFilters) =>
    set(() => ({
      detailMediaId: id,
      detailMediaFilters: mediaFilters,
    })),
  setDetailMediaId: (id?: string) =>
    set(() => ({
      detailMediaId: id,
    })),
  setDetailMediaFilters: (mediaFilters: MediaFilters) =>
    set(() => ({
      detailMediaFilters: mediaFilters,
    })),
  setHasPendingChanges: (hasPendingChanges: boolean) =>
    set(() => ({
      hasPendingChanges,
    })),
  setStartingSafetyReview: (startingSafetyReview: boolean) =>
    set(() => ({
      startingSafetyReview,
    })),
  setUseTableFilters: (useTableFilters: boolean) =>
    set(() => ({
      useTableFilters,
    })),
});

export default mediaDetailsSlice;
